// core/env.ts — Platik-IA
// Único punto de acceso a variables de entorno del cliente.
// NUNCA importar import.meta.env fuera de este archivo.

import { z } from 'zod';

const schema = z.object({
  VITE_SUPABASE_URL:      z.string().url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(20),
  VITE_GOOGLE_CLIENT_ID:  z.string().min(10),
  VITE_APP_URL:           z.string().url(),
});

function parseEnv() {
  const result = schema.safeParse({
    VITE_SUPABASE_URL:      import.meta.env.VITE_SUPABASE_URL,
    VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
    VITE_GOOGLE_CLIENT_ID:  import.meta.env.VITE_GOOGLE_CLIENT_ID,
    VITE_APP_URL:           import.meta.env.VITE_APP_URL,
  });

  if (!result.success) {
    const missing = result.error.errors.map(e => e.path.join('.')).join(', ');
    throw new Error(`[env] Variables de entorno faltantes o inválidas: ${missing}`);
  }

  return result.data;
}

export const env = parseEnv();
